import { FromTypes } from './types';
export class ToSubTypes {
}
ToSubTypes.ps = 'PostScript';
ToSubTypes.pdf = 'Adobe PDF';
ToSubTypes.ebook = 'E-Book';
ToSubTypes.office = 'MS Office';
ToSubTypes.imageResize = 'Image Resize';
ToSubTypes.imageConvert = 'Image Convert';
ToSubTypes.imageCompress = 'Image Compress';
ToSubTypes.meme = 'Meme';
ToSubTypes.videoConvert = 'Video Convert';
ToSubTypes.videoCompress = 'Video Compress';
ToSubTypes.audio = 'Audio';
ToSubTypes.webtool = 'Web Tools';
ToSubTypes.imageMerge = 'Image Merge';
ToSubTypes.audioCompress = 'Audio Compress';
ToSubTypes.fileArchive = 'File Archive';
ToSubTypes.files = 'Files';
/**
* These defines types of input files we can consume.
* I.e. docx, doc belong to input type 'word', mp4, webm, avi... belongs to type 'video'
*/
export class ConvertFrom {
}
export class ConvertFromWord extends ConvertFrom {
}
ConvertFromWord.TYPE = FromTypes.WORD;
ConvertFromWord.EXTENTIONS = ['doc', 'docx'];
export class ConvertFromExcel extends ConvertFrom {
}
ConvertFromExcel.TYPE = FromTypes.EXCEL;
ConvertFromExcel.EXTENTIONS = ['xls', 'xlsx'];
export class ConvertFromPowerPoint extends ConvertFrom {
}
ConvertFromPowerPoint.TYPE = FromTypes.POWERPOINT;
ConvertFromPowerPoint.EXTENTIONS = ['ppt', 'pptx'];
export class ConvertFromPDF extends ConvertFrom {
}
ConvertFromPDF.TYPE = FromTypes.PDF;
ConvertFromPDF.EXTENTIONS = ['pdf'];
export class ConvertFromPS extends ConvertFrom {
}
ConvertFromPS.TYPE = FromTypes.PS;
ConvertFromPS.EXTENTIONS = ['ps'];
export class ConvertFromImage extends ConvertFrom {
}
ConvertFromImage.TYPE = FromTypes.IMAGE;
ConvertFromImage.EXTENTIONS = ['jpeg', 'jpg', 'png', 'bmp', 'webp', 'gif', 'tif', 'tiff', 'cr2', 'nef', 'heic'];
export class ConvertFromEbook extends ConvertFrom {
}
ConvertFromEbook.TYPE = FromTypes.EBOOK;
ConvertFromEbook.EXTENTIONS = ['epub', 'mobi', 'pdf'];
export class ConvertFromVideo extends ConvertFrom {
}
ConvertFromVideo.TYPE = FromTypes.VIDEO;
ConvertFromVideo.EXTENTIONS = ['mts', '3gp', 'avi', 'flv', 'm4v', 'mkv', 'mp4', 'mpeg', 'mpg', 'vob', 'webm', 'wmv', 'mov'];
export class OfflineFromAny extends ConvertFrom {
}
OfflineFromAny.TYPE = FromTypes.FILES;
OfflineFromAny.EXTENTIONS = [];
export class OnlineFromAny extends ConvertFrom {
}
OnlineFromAny.TYPE = FromTypes.FILES;
OnlineFromAny.EXTENTIONS = [];
export class ConvertFromArchive extends ConvertFrom {
}
ConvertFromArchive.TYPE = FromTypes.ARCHIVE;
ConvertFromArchive.EXTENTIONS = ["rar", "7z", "tar.gz", "tar.bz2", "tar.xz", "zip", "rar", "tar", "bz2", "gz", "lz4", "lzma", "xz"];
export class ConvertFromAudio extends ConvertFrom {
}
ConvertFromAudio.TYPE = FromTypes.AUDIO;
ConvertFromAudio.EXTENTIONS = [
    'mp3', 'aac', 'ogg', 'flac', 'aiff', 'mmf', 'm4a', 'wma', 'wav', 'm4r', 'opus',
];
export class ConvertFromAV extends ConvertFrom {
}
ConvertFromAV.TYPE = FromTypes.AV;
ConvertFromAV.EXTENTIONS = [
    'mts', '3gp', 'avi', 'flv', 'm4v', 'mkv', 'mp4', 'mpeg', 'mpg', 'vob', 'webm', 'wmv', 'mov',
    'mp3', 'aac', 'ogg', 'flac', 'aiff', 'mmf', 'm4a', 'wma', 'wav', 'm4r', 'opus',
];
